const hardSkillList = [
  {
    title: 'Technology',
    contents: [
      'Android Studio',
      'React Js',
      'React Native',
      'Firebase',
      'Arduino IDE',
    ],
  },
  {
    title: 'Languages',
    contents: [
      'HTML',
      'CSS',
      'Javascript',
      'Java',
      'Python',
      'C++',
      'Typescript',
    ],
  },
  {
    title: 'Tools',
    contents: [
      'Git & Github',
      'Notion',
      'Trello',
      'Jira',
      'Figma',
      'Easy Eda',
    ],
  },
]

export default hardSkillList